const store = {
  namespaced: true,
  state: {
    maintenanceItemDetailLoading: false
  },
  getters: {},
  mutations: {
    setMaintenanceItemDetailLoading(state, status) {
      state.maintenanceItemDetailLoading = status;
    }
  },
  actions: {
    async getVehicleInfoByModeCode({ rootState }, params = {}) {
      const data = await rootState.http("/vehicleMatching/getVehicleMatchingInfo", params);
      return data;
    },
    async queryVehicleModelDetail({ rootState }, params = {}) {
      const data = await rootState.http("/vehicleModel/getVehicleModelDetail", params);
      return data;
    },
    async queryMaintenanceItem({ rootState }, params = {}) {
      const data = await rootState.http("/vehicleModel/getMaintenanceItem", params);
      return data;
    },
    async queryMileageCycles({ rootState }, params = {}) {
      const data = await rootState.http("/vehicleModel/getMileageCycles", params);
      return data;
    },
    async queryMonthCycles({ rootState }, params = {}) {
      const data = await rootState.http("/vehicleModel/getMonthCycles", params);
      return data;
    },
    async queryMaintenanceItemDetail({ rootState }, params = {}) {
      const data = await rootState.http("/vehicleModel/getMaintenanceItemDetail", params);
      return data;
    },
    async queryRemainderOverview({ rootState }, params = {}) {
      const data = await rootState.http("/vehicleModel/balance/overview", params);
      return data;
    },
    async queryRechargeItemList({ rootState }, params = {}) {
      const data = await rootState.http("/vehicleModel/balance/queryRechargeItemList", params);
      return data;
    },
    async createRechargeOrder({ rootState }, params = {}) {
      const data = await rootState.http("/vehicleModel/balance/createRechargeOrder", params);
      return data;
    },
    async queryRechargeOrder({ rootState }, params = {}) {
      const data = await rootState.http("/vehicleModel/balance/queryRechargeOrder", params);
      return data;
    },
    async queryConsumeOrder({ rootState }, params = {}) {
      const data = await rootState.http("/vehicleModel/balance/queryConsumeOrder", params);
      return data;
    },
    async queryAccessScopeList({ rootState }, params = {}) {
      const data = await rootState.http("/vehicleModel/getAccessScopeList", params);
      return data;
    },
    async queryRechargeSuccessful({ rootState }, params = {}) {
      const data = await rootState.http("/vehicleModel/balance/isRechargeSuccessful", params);
      return data;
    },
    async queryRechargeOverview({ rootState }, params = {}) {
      const data = await rootState.http("/vehicleModel/balance/overview", params);
      return data;
    }
  }
};

export default store;
